import React from 'react';
import FontAwesome from 'react-fontawesome';



class SymbolSelectItem extends React.Component {


    constructor(props) {
        super(props);

        this.state = {
            imageError: false
        }

        this.handleImageLoaded = this.handleImageLoaded.bind(this);
        this.handleImageError = this.handleImageError.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
    }

    handleSelect(e) {
        e.preventDefault();
        this.props.onSymbolSelect(this.props.symbol);
    }

    handleImageLoaded() {
        this.props.onSymbolLoadComplete();
    }

    handleImageError() {
        this.setState({imageError: true});
    }

    render() {

        if (this.state.imageError)
            return null;

        return (
            <div className="symbol_select_item">
                <a href="#" onClick={this.handleSelect}>
                    <img 
                        onLoad={this.handleImageLoaded}
                        onError={this.handleImageError}
                        src={this.props.symbol.getSymbolUrl()} 
                        alt="" 
                        title={this.props.symbol.title + ' (klick mich)'} 
                    />
                </a>
            </div>
        );
    }
}

export default SymbolSelectItem;



// WEBPACK FOOTER //
// ./src/SymbolSelectItem.js